module.exports = __webpack_public_path__ + "static/media/med-fires-ajina.77864a72.jpg";